import React from "react";
import { UseFormReturn } from "react-hook-form";

import { Button } from "../../../components/button";
import { CardHeader } from "../../../components/cards";

interface ISentinelForm {
  loading: boolean;
  submit: any;
  form: UseFormReturn<any, any>;
  disabledFields?: string[];
}

export const SentinelForm: React.FC<ISentinelForm> = ({
  loading,
  submit,
  form,
  disabledFields = [],
}) => {
  return (
    <div className="">
      <div className="mb-2"></div>

      <div className="card">
        <CardHeader title="Sentinelle" />

        <div className="w-full mb-2">
          <p className="label">Nom</p>
          <input
            className="w-full input"
            {...form.register("name", {
              required: "Le nom est requis",
            })}
            placeholder="Nom du vps"
          />
        </div>
        <div className="w-full mb-2">
          <p className="label">ip</p>
          <input
            className="w-full input"
            {...form.register("ip", {
              required: "L'ip est requis",
            })}
            placeholder="210.0.0.9"
          />
        </div>

        <div className="w-full py-3">
          <Button
            disabled={!form.formState.isValid}
            loading={loading}
            onClick={submit}
          >
            Valider
          </Button>
        </div>
      </div>
    </div>
  );
};
